import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdministratorService } from 'src/app/core/servicie/administrador.service';
import { Parametric } from 'src/app/shared/enums/parametric.enum';
import { Country, Department, IParametric, Locality, Municipality } from 'src/app/shared/interfaces/parametric.interface';
import { PopupTermsconditionsComponent } from '../popup-termsconditions/popup-termsconditions.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { OtpValidationComponent } from '../otp-validation/otp-validation.component';
import { IntegromatService } from 'src/app/core/servicie/integromat.service';
import { environment } from 'src/environments/environment';
registerLocaleData(localeEs);
@Component({
  selector: 'app-titans-form',
  templateUrl: './titans-form.component.html',
  styleUrls: ['./titans-form.component.scss'],
})
export class TitansFormComponent implements OnInit {
  group: FormGroup= this.formBuilder.group({});
  contadorButton: number = 0;
  textButton: string = '';
  textButtonAnt: string = '';
  typeDocuments: IParametric[]=[];
  countryCodes: Country[]=[];
  genders: IParametric[]=[];
  departmentsDescription: Department[]=[];
  municipalities: Municipality[]=[];
  localities: Locality[]=[];
  codesParametrics = Parametric;
  textDocument: string = '';
  genderDescription: string = '';
  minDate: Date;
  maxDate: Date;
  opcion1: boolean = false;
  opcion2: boolean = false;
  opcion3: boolean = false;
  opcion4: boolean = false;
  checkboxes = [
    { label: 'Venta de vehículos', value: 'first_checkbox', checked: false, tooltip: '', disabled: false },
    { label: 'Financiación de Vehiculos', value: 'second_checkbox', checked: false, tooltip: '', disabled: false },
    { label: 'Mantenimiento de Vehiculos', value: 'third_checkbox', checked: false, tooltip: '', disabled: false },
    { label: 'Seguros de vehículos', value: 'fourth_checkbox', checked: false, tooltip: '', disabled: false },
    { label: 'Otros seguros', value: 'five_checkbox', checked: false, tooltip: '', disabled: false },
    { label: 'Otras actividades relacionas con vehículos', value: 'six_checkbox', checked: false, tooltip: '', disabled: false },
    { label: 'Ninguna de las anteriores pero me interesa', value: 'seven_checkbox', checked: false, tooltip: '', disabled: false },
  ];

  utmSource   = '';
  utmMedium   = '';
  utmCampaign = '';
  utmContent  = '';
  formEnviado = false;

  constructor(
    private administratorService: AdministratorService, public dialog: MatDialog, 
    private readonly formBuilder: FormBuilder,
    private translate: TranslateService,
    private route: ActivatedRoute ,
    private integromatService:IntegromatService
  ){
    translate.setDefaultLang('es');
    translate.use('es');
    const today = new Date();
    this.maxDate = new Date(today.getFullYear() - 16, today.getMonth(), today.getDate());
    this.minDate = new Date(today.getFullYear() - 80, today.getMonth(), today.getDate());
  }

  ngOnInit(){
    this.createForm();
    this.route.queryParamMap.subscribe(params => {
      this.utmSource   = params.get('utm_source')   ?? '';
      this.utmMedium   = params.get('utm_medium')   ?? '';
      this.utmCampaign = params.get('utm_campaign') ?? '';
      this.utmContent  = params.get('utm_content')  ?? '';

      this.group.patchValue({
        utm_source:   this.utmSource,
        utm_medium:   this.utmMedium,
        utm_campaign: this.utmCampaign,
        utm_content:  this.utmContent,
      });
    });

    this.translate.get('CONTINUAR').subscribe((translation: string) => {
      this.textButton = translation;
    });
    this.translate.get('ANTERIOR').subscribe((translation: string) => {
      this.textButtonAnt = translation;
    });
    this.administratorService.getParametric(this.codesParametrics.IdentificationType).subscribe(resp=>{
      this.typeDocuments = resp;
      this.change("CC");
    })
    this.administratorService.getCountry().subscribe(resp=>{
      this.countryCodes= resp;
    })
    this.administratorService.getDepartment().subscribe(resp=>{
      this.departmentsDescription= resp;
    })
    this.administratorService.getParametric(this.codesParametrics.Gender).subscribe(resp=>{
      this.genders = resp;
    })
  }

  nextPage() {
  if(this.isButtonDisabled())
    return;
  this.contadorButton === 2 ? this.contadorButton : this.contadorButton++;
  if (this.contadorButton === 2) {
    this.translate.get('ENVIAR').subscribe((res: string) => {
      this.textButton = res; 
    });
    } else {
      this.translate.get('CONTINUAR').subscribe((res: string) => {
        this.textButton = res; 
      });
    }
  } 


  backPage(){
    this.contadorButton === 0 ? this.contadorButton : this.contadorButton--;
    if (this.contadorButton === 2) {
    this.translate.get('ENVIAR').subscribe((res: string) => {
      this.textButton = res; 
    });
    } else {
      this.translate.get('CONTINUAR').subscribe((res: string) => {
        this.textButton = res; 
      });
    }
  }

  onCheckboxChange(index: number) {
    const maxAllowed = 6;
    this.checkboxes[index].checked = !this.checkboxes[index].checked;
  
    const checkedCount = this.checkboxes.filter(cb => cb.checked).length;
  
    if (checkedCount > maxAllowed) {
      this.checkboxes[index].checked = false;
    } else {
      this.checkboxes.forEach((cb, i) => {
        if (i !== index) {
          cb.disabled = checkedCount >= maxAllowed && !cb.checked;
        }
      });
    }

    let checkedList=this.checkboxes.filter(x=>x.checked);
    let label = checkedList.filter(x => x.checked)
      .map(x => x.label)
      .join(',');
    this.group.patchValue({
      experiences:label
    });
  } 

  change(event:any){
    this.textDocument = this.typeDocuments.filter(type => type.code===event)[0].description;
  }

  changeMunicipality(event:any){
    this.localities=[];
    this.group.patchValue({
      locality:""
    });
    this.administratorService.getMunicipality(event).subscribe(resp=>{
      this.municipalities= resp;    
    })
  }

  changeLocalities(event:any){
    const departmentCode=this.group.get("department")?.value;
    this.administratorService.changeLocalities(departmentCode,event).subscribe(resp=>{
      this.localities= resp;   
      if (this.localities && this.localities.length) {
        this.group.get('locality')?.setValidators([Validators.required]);
      } else {
        this.group.get('locality')?.clearValidators();
      } 
    })
  }

  abrirPopupterms(): void {
    const dialogRef = this.dialog.open(PopupTermsconditionsComponent, {
      width: '80vw',
      height: '80vh',
      panelClass: 'box-pupop-aliado',
      data: {  }
    });
  }

  createForm(): void {
    this.group = this.formBuilder.group({
      name:      ['', [Validators.required, Validators.maxLength(40),Validators.pattern('^(?=\\s*\\S)[a-zA-Z0-9\\sÁÉÍÓÚÜÑáéíóúüñ]+$')]],
      lastName:  ['', [Validators.required, Validators.maxLength(80),Validators.pattern('^(?=\\s*\\S)[a-zA-Z0-9\\sÁÉÍÓÚÜÑáéíóúüñ]+$')]],
      typeDocument:  ['CC', [Validators.required]],
      numberDocument:  ['', [Validators.required,Validators.pattern(/^\d{6,10}$/),Validators.maxLength(10)]],
      email:     ['', [Validators.required, Validators.maxLength(40),Validators.pattern('^[a-zA-Z0-9_]+([.\-][a-zA-Z0-9_]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{2,5}$')]],
      country:['+57', [Validators.required]],
      phone:['', [Validators.required,Validators.minLength(5),Validators.maxLength(15),Validators.pattern('^[0-9]+$')]],
      gender:['', [Validators.required]],
      department:['', [Validators.required]],
      city:['', [Validators.required]],
      locality:['', []],
      system:['', [Validators.required]],
      commissions:['', [Validators.required]],
      terminos: [false, Validators.requiredTrue],
      experiences: ["",Validators.required],
      birthdate: ['', Validators.required],
      utm_source:   [''],
      utm_medium:   [''],
      utm_campaign: [''],
      utm_content:  [''],
      form_name:['Formulario_Titanes'],
      concatenate:['']
    });
    this.group.get('typeDocument')?.valueChanges.subscribe(value => {
      this.applyDocumentValidators(value);
    });
    this.group.get('country')?.valueChanges.subscribe(value => {
      this.concatenarPhone(value,this.group.get("phone")?.value);
    });
    this.group.get('phone')?.valueChanges.subscribe(value => {
      this.concatenarPhone(this.group.get("country")?.value,value);
    });
  }  

  applyDocumentValidators(type: string): void {
    const numberDocument = this.group.get('numberDocument');
    numberDocument?.clearValidators();

    switch (type) {
      case 'CC':
        numberDocument?.setValidators([
          Validators.required,
          Validators.pattern(/^\d{6,10}$/),
          Validators.maxLength(10)
        ]);
        break;
      case 'CE': 
        numberDocument?.setValidators([
          Validators.required,
          Validators.pattern(/^\d{6,10}$/), 
          Validators.maxLength(10)
        ]);
        break;
      case 'NIT':
        numberDocument?.setValidators([
          Validators.required,
          Validators.pattern(/^\d{8,10}$/), 
          Validators.maxLength(10)
        ]);
        break;
      case 'PAS':
        numberDocument?.setValidators([
          Validators.required,
          Validators.pattern(/^[A-Z]{2}[0-9]{6}$/), 
          Validators.maxLength(8)
        ]);
        break;
      case 'REGCIV': 
        numberDocument?.setValidators([
          Validators.required,
          Validators.pattern(/^\d{10}$/),
          Validators.maxLength(10)
        ]);
        break;
      case 'TI': 
        numberDocument?.setValidators([
          Validators.required,
          Validators.pattern(/^\d{10}$/), 
          Validators.maxLength(10)
        ]);
        break;
      case 'CARDIPL': 
        numberDocument?.setValidators([
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]{8}$/), 
          Validators.maxLength(8)
        ]);
        break;
      default:
        numberDocument?.setValidators([Validators.required, Validators.maxLength(15)]);
    }

    numberDocument?.updateValueAndValidity();
  }

  concatenarPhone(valueOne:string,valueTwo:string){
    const codeCountry=valueOne;
    const phoneValue=valueTwo;
    this.group.patchValue({
      concatenate:codeCountry+phoneValue
    })
  }

  isButtonDisabled(): boolean {
    this.touchCurrentSectionControls();
    if (this.contadorButton === 0) {
      return !this.group.get('name')?.valid || !this.group.get('lastName')?.valid 
      || !this.group.get('typeDocument')?.valid || !this.group.get('numberDocument')?.valid ||  !this.group.get('email')?.valid;
    } else if (this.contadorButton === 1) {
      return !this.group.get('birthdate')?.valid || !this.group.get('country')?.valid || !this.group.get('phone')?.valid || !this.group.get('gender')?.valid 
      || !this.group.get('department')?.valid ||  !this.group.get('city')?.valid ||  !this.group.get('locality')?.valid ;
    } else if (this.contadorButton === 2) {
      return !this.group.get('system')?.valid || !this.group.get('commissions')?.valid || !this.group.get('terminos')?.valid;
    }
    return true; 
  }

  touchCurrentSectionControls() {
    if (this.contadorButton === 0) {
      ['name', 'lastName', 'typeDocument', 'numberDocument', 'email'].forEach(field => {
        this.group.get(field)?.markAsTouched();
      });
    } else if (this.contadorButton === 1) {
      ['birthdate', 'country', 'phone', 'gender', 'department', 'city', 'locality'].forEach(field => {
        this.group.get(field)?.markAsTouched();
      });
    } else if (this.contadorButton === 2) {
      ['system', 'commissions', 'terminos'].forEach(field => {
        this.group.get(field)?.markAsTouched();
      });
    }
  }

  send(): void {
    let experiences=this.checkboxes.filter(x=>x.checked);
    if(experiences.length){
      this.dialog.open(OtpValidationComponent, {
        maxHeight: '90vh',
        panelClass: 'custom-dialog-container',    
        data: {
          phoneNumber: this.group.get('phone')?.value,
          country: this.group.get('country')?.value,
          group:this.group.value,
          submitForm: (dataSend:any,isValid: boolean) => this.submitForm(dataSend,isValid)
        }
      });
    }else{
      
    }
    
  }

  submitForm(dataSend:any,isValid=false){
    if(isValid){
        this.integromatService.postTitan([dataSend]).subscribe(data=>{
          window.parent.postMessage(
            { tipo: 'OKENVIO',  },
            environment.registroTitanUrl
          )
        },error=>{
          
        })
    }
  }
  
}


